module.exports = __webpack_public_path__ + "static/img/4.9a75b28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/questionnaire/4.png
// module id = EAjM
// module chunks = 1